var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArnoldIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 43,
    viewBox: "0 0 58 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3593 31.8096C44.3078 31.8096 45.8874 30.2265 45.8874 28.2737C45.8874 26.3209 44.3078 24.7378 42.3593 24.7378C40.4108 24.7378 38.8312 26.3209 38.8312 28.2737C38.8312 30.2265 40.4108 31.8096 42.3593 31.8096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5977 31.8098C17.5462 31.8098 19.1257 30.2267 19.1257 28.2739C19.1257 26.3211 17.5462 24.738 15.5977 24.738C13.6492 24.738 12.0696 26.3211 12.0696 28.2739C12.0696 30.2267 13.6492 31.8098 15.5977 31.8098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2329 37.8032H43.8221V42.719H50.2329V37.8032Z",
    fill: "#01AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8222 37.8032H7.07862C6.6914 37.8032 6.34719 37.5014 6.30417 37.1133V42.719H43.8222V37.8032Z",
    fill: "#117BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3042 37.0273V25.126H0.839996V37.286C0.839996 40.3044 3.24941 42.7192 6.26117 42.7192H6.3042V37.1135C6.3042 37.0704 6.3042 37.0704 6.3042 37.0273Z",
    fill: "#01AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.839996 19.2184V25.1259H6.3042V19.4771C6.3042 19.089 6.60537 18.744 6.9926 18.7009H0.883022C0.839996 18.8734 0.839996 19.0459 0.839996 19.2184Z",
    fill: "#0092C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00302 13.7852C3.29244 13.9145 1.09815 16.0274 0.883026 18.7009H6.9926C7.03563 18.7009 7.03563 18.7009 7.07865 18.7009H45.285V13.7852H6.00302Z",
    fill: "#0ED6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2419 13.7852V18.7009H50.9161C51.3059 18.7009 51.6524 19.0027 51.6957 19.3908V13.7852H45.2419Z",
    fill: "#0CC4E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.997 13.7852H51.6958V19.3908C51.6958 19.4339 51.6958 19.4339 51.6958 19.4771V36.4234H57.16V19.2183C57.117 16.2861 54.8366 13.9145 51.997 13.7852Z",
    fill: "#13E0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2471 6.77558V12.7915H30.2693V6.68934C31.603 6.25814 32.5926 5.09388 32.5926 3.6709C32.5926 1.90296 31.0437 0.47998 29.1076 0.47998C27.2145 0.47998 25.6225 1.90296 25.6225 3.6709C25.6656 5.18012 26.7842 6.43062 28.2471 6.77558Z",
    fill: "#01AAE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.32,
    height: 42.239,
    fill: "white",
    transform: "translate(0.839996 0.47998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArnoldIconLight);
export default __webpack_public_path__ + "static/media/ArnoldIconLight.f3ac858a4f6ecec81eb12911dd8f5059.svg";
export { ForwardRef as ReactComponent };